export const REMOVE_TAG_TEXT = "remove";